import React from "react";

export default (props) => {

  return (
    <React.Fragment>

      <h1 className="page-title">Contacts</h1>
      <p>If you have any questions relating to the MyScan service or would like to check if you can use Darlington MyScan for your claim, please contact Darlington Borough Council.</p>
      <p>You can contact Darlington Borough Council via</p>
      <p><a href="mailto:customerservices@darlington.gov.uk">customerservices@darlington.gov.uk</a></p>

    </React.Fragment>
  );
}
